import { baseAIURL } from './baseAIURL';

export function generateQuestionURL() {
  const url = baseAIURL();
  url.pathname += 'questions/';
  return url;
}
